const GENERAL = {
  IMAGE_PATH: 'https://www.viacor.de/images/systemimages/',
  clientUrl: {
    development: 'http://localhost:8080',
    staging: 'https://staging.app.viacor.de',
    production: 'https://app.viacor.de',
  },
};

export default GENERAL;
